import React from 'react';
import AspectRatio from '@jbhi-fi/lanyard-ui/components/AspectRatio/AspectRatio';
import { StackYoutubePlayer } from '@jbhi-fi/components/src/StackYouTubePlayer/StackYouTubePlayer';
import { ContentfulImage } from '@jbhi-fi/components/src/ContentfulImage/ContentfulImage';
import { styles } from './ArticleHeader.css';
import { LoadingSkeleton } from '@jbhi-fi/components/src/LoadingSkeleton/LoadingSkeleton';
import { VideoPlayer } from '@jbhi-fi/components/src/VideoPlayer/VideoPlayer';
import { useBreakpoint } from '@jbhi-fi/lanyard-ui/utils/useBreakpoint';
import { YoutubePlayerProps } from '@jbhi-fi/components/src/YouTubePlayer/YouTubePlayer';

export const ARTICLE_HERO_IMAGE_ASPECT_RATIO = 1124 / 364;
export const ARTICLE_HERO_IMAGE_MOBILE_ASPECT_RATIO = 20 / 9;

export type ArticleHeaderProps = {
  coverImgSrc: string;
  coverImgAlt: string;
  videoSrc?: string;
  contentType?: string;
  videoPlatform?: 'youTube' | 'html';
  videoType?: string;
  youTubeProps?: YoutubePlayerProps;
};

export const ArticleHeader: React.FC<ArticleHeaderProps> = props => {
  if (props.videoSrc || props.youTubeProps?.videoUrl) {
    return <VideoArticleHeader {...props} />;
  }
  return <StandardArticleHeader {...props} />;
};

const StandardArticleHeader: React.FC<ArticleHeaderProps> = ({ coverImgSrc, coverImgAlt }) => {
  const isMobile = useBreakpoint('sm', 'down');
  const aspectRatio = isMobile ? ARTICLE_HERO_IMAGE_MOBILE_ASPECT_RATIO : ARTICLE_HERO_IMAGE_ASPECT_RATIO;
  return (
    <div className={styles.headerContainer}>
      <AspectRatio ratio={aspectRatio}>
        {coverImgSrc ? (
          <ContentfulImage
            src={coverImgSrc}
            alt={coverImgAlt}
            aspectRatio={aspectRatio}
            sizes="(max-width: 1124px) 100vw, 1124px"
            width="1124px"
            height="364px"
          />
        ) : (
          <LoadingSkeleton.Box shouldShimmer={false} width="100%" height="100%" />
        )}
      </AspectRatio>
    </div>
  );
};

const VideoArticleHeader: React.FC<ArticleHeaderProps> = ({
  videoSrc = '',
  videoPlatform = 'youTube',
  videoType = 'video/mp4',
  youTubeProps = {},
}) => {
  return (
    <div className={styles.videoHeaderContainer}>
      <div className={styles.videoHeaderInnerContainer}>
        {videoPlatform === 'youTube' ? (
          <StackYoutubePlayer {...youTubeProps} />
        ) : (
          <VideoPlayer src={videoSrc} type={videoType} />
        )}
      </div>
    </div>
  );
};
